/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { FaWrench } from "react-icons/fa";
import { crudDe } from "../../../../services/acesso";
import api from "../../../../services/api";
import { useEffect, useState } from "react";
import Listagem from "../../../../components/listagem";
import { useAppSelector } from "../../../../store/hooks";
import ModalForm from "../../../../components/modal-form";
import ModalImportacao from "../../../../components/modal-importacao";
import { TipoFormulario } from "../../../../services/constantes";
import { ApiError, Campo, Servico } from "../../../../services/tipos";
import { LocaSmartLayout } from "../../../../components/locasmart-layout";
import { obterIdTenent, usuarioTemPermissao } from "../../../../services/seguranca";
import { useFiliais } from "../../../../hooks/useFiliais";
import { CAMPOS_SERVICO } from "../../../../services/importacao";

function ServicoListagem() {
    const { empresaTemFiliais, filiaisOptions, getCampoFilial, getAcaoEmLoteFilial } = useFiliais();
    const [servicos, setServicos] = useState<Servico[]>([]);
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [servicoSelecionado, setServicoSelecionado] = useState<Servico>({} as Servico);
    const [showModalImportacao, setShowModalImportacao] = useState<boolean>(false);

    const colunas = [
        { field: 'nome', headerName: 'Nome', flex: 1 },
        { field: 'valor', headerName: 'Valor', flex: 1 },
        { field: 'periodoEmKm', headerName: 'Periodicidade em Quilometros', flex: 1 },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', flex: 1, renderCell: (params: any) => { if (!params.value) return ''; const f = filiaisOptions.find((x: any) => x.valor === params.value); return f?.label || ''; } }] : []),
    ];

    const campoFilial = getCampoFilial({ linha: 0, coluna: 1, largura: 12 });

    const campos: Campo[] = [
        ...(campoFilial ? [campoFilial] : []),
        { label: 'Nome', nome: 'nome', required: true, tipo: 'text', largura: 12, coluna: 1, linha: 1, visible: true, tudoMaiusculo: true },
        {
            label: 'Valor', nome: 'valor', required: true, tipo: 'money', largura: 6, coluna: 2, linha: 2, visible: true, ajudinha: {
                texto: "Este campo refere-se ao valor do serviço, sendo sugerido como valor base nas movimentações de Manutenções.",
                autoCloseTime: 3
            }
        },
        {
            label: 'Periodicidade em KM', nome: 'periodoEmKm', required: false, tipo: 'number', largura: 6, coluna: 1, linha: 2, visible: true,
            ajudinha: {
                texto: "Este campo se refere à vida útil do serviço em quilômetros. \nEle será utilizado posteriormente pela nossa inteligência artificial para identificar a necessidade de realizar a próxima manutenção.",
                autoCloseTime: 3
            }
        },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 3, visible: false, tudoMaiusculo: true },
    ];

    const temPermissao = usuarioTemPermissao(token, 'servico_visualizar');

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        toast.error("Não foi possível continuar a operação serviço: " + error.response?.data.Mensagem);
    }

    const requisicaoBemSucedida = (response: any) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success("Serviço salvo com sucesso");
        setFezAlgumaAcao(true);
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    const handleCadastrar = () => {
        if (usuarioTemPermissao(token, 'servico_novo')) {
            setModo(TipoFormulario.tpCadastro)
            setServicoSelecionado({ periodoEmKm: 0 } as Servico);
            setExibirFormModal(true);
        } else {
            toast.error("Você não tem permissão para cadastrar um novo serviço");
        }
    }

    const handleEditar = (servico: any) => {
        if (usuarioTemPermissao(token, 'servico_editar')) {
            setModo(TipoFormulario.tpEdicao)
            setServicoSelecionado(servico);
            setExibirFormModal(true);
        } else {
            toast.error("Você não tem permissão para editar um serviço");
        }
    }

    const handleExclusao = async (servico: Servico) => {
        if (usuarioTemPermissao(token, 'servico_excluir')) {
            setCarregando(true);
            await api.delete(`/servico/${servico.id}`)
                .then(response => {
                    setTimeout(() => {
                        toast.success("Serviço foi excluído com sucesso");
                        setRealizarConsulta(true)
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    tratarErro(error);
                });
        }
    }

    const handleVisualizacao = (servico: any) => {
        if (usuarioTemPermissao(token, 'servico_visualizar')) {
            setServicoSelecionado(servico);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao)
        }
    }

    useEffect(() => {
        const fetchServicoPorEmpresa = async() => {
            if ((temPermissao) && (realizarConsulta)) {
                setCarregando(true);
                await api.get(`/servicoPorEmpresa/${obterIdTenent(token)}`)
                    .then(response => {
                        setTimeout(() => {
                            setServicos(response.data);
                            setRealizarConsulta(false);
                            setCarregando(false);
                        }, 250);
                    }).catch((error: AxiosError<ApiError>) => {
                        setCarregando(false);
                        tratarErro(error);
                    });
            }
        }

        fetchServicoPorEmpresa();
    }, [temPermissao, realizarConsulta, token]);

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={crudDe('servico')}
                    colunas={colunas}
                    linhas={servicos}
                    nomeEntidade="Serviço"
                    nomePropriedade="nome"
                    carregando={carregando}
                    IconeEntidade={FaWrench}
                    exibirAcoesDeCrud={true}
                    handleEditar={handleEditar}
                    handleCriar={handleCadastrar}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setServicoSelecionado}
                    onImportar={() => setShowModalImportacao(true)}
                    acoesEmLote={[
                        ...(getAcaoEmLoteFilial('Servico', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('Servico', () => setRealizarConsulta(true))!] : []),
                    ]}
                />

                <ModalImportacao
                    show={showModalImportacao}
                    onHide={() => setShowModalImportacao(false)}
                    titulo="Importar Serviços"
                    campos={CAMPOS_SERVICO}
                    nomeTemplate="template-servicos"
                    camposFixos={{ idEmpresa: obterIdTenent(token), dataCadastro: new Date().toISOString() }}
                    enviar={async (item) => { await api.post('/servico', item); }}
                    permitirAtualizacao
                    chaveMatch="nome"
                    rotuloCampo="nome"
                    buscarExistentes={async () => {
                        const resp = await api.get(`/servicoPorEmpresa/${obterIdTenent(token)}`);
                        return resp.data || [];
                    }}
                    atualizar={async (item) => { await api.put('/servico', item); }}
                    onImportacaoConcluida={() => setRealizarConsulta(true)}
                />

                <ModalForm
                    modo={modo}
                    tamanho="lg"
                    campos={campos}
                    show={exibirFormModal}
                    carregando={carregando}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    ajudinha={
                        {
                            texto: "Aqui você poderá cadastrar serviços que serão utilizados em movimentações, como a de Manutenções. Esses cadastros facilitam a seleção nas telas de movimentação, garantindo uma escolha rápida e a padronização das operações.",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={servicoSelecionado}
                    apiConfig={
                        {
                            endpoint: "servico",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                />
            </LocaSmartLayout>
        </>
    );
}

export default ServicoListagem;